// extracted by mini-css-extract-plugin
export var LB = "TopBanner-module--LB--bd49d";
export var Sticking = "TopBanner-module--Sticking--f0899";
export var TopLB = "TopBanner-module--TopLB--9d7fc";
export var Unstuck = "TopBanner-module--Unstuck--0c017";
export var Wrapper = "TopBanner-module--Wrapper--1cb4a";